/**
 * Brief local storage key for saving/fetching its data
 * @type {String}
 */
export const BRIEF_LOCAL_STORAGE_KEY = 'brief-runtime';

/**
 * Brief logo name data key
 * @type {String}
 */
export const LOGO_NAME_STEP = 'logo_name';
